import { render } from "./AddHighlightModal.vue?vue&type=template&id=0f53587e&scoped=true"
import script from "./AddHighlightModal.vue?vue&type=script&lang=js"
export * from "./AddHighlightModal.vue?vue&type=script&lang=js"

import "./AddHighlightModal.vue?vue&type=style&index=0&id=0f53587e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f53587e"]])

export default __exports__